import { useRef, useState } from "react";
import { Play, Pause, Volume2, VolumeX } from "lucide-react";
import { ASSETS } from "@/lib/assets";
import { Reveal } from "@/components/site/Reveal";

export const VideoShowcase = () => {
  const videoRef = useRef(null);
  const [playing, setPlaying] = useState(true);
  const [muted, setMuted] = useState(true);

  const togglePlay = () => {
    const v = videoRef.current;
    if (!v) return;
    if (v.paused) {
      v.play();
      setPlaying(true);
    } else {
      v.pause();
      setPlaying(false);
    }
  };

  const toggleMute = () => {
    const v = videoRef.current;
    if (!v) return;
    const next = !v.muted;
    v.muted = next;
    if (!next && v.paused) {
      v.play();
      setPlaying(true);
    }
    setMuted(next);
  };

  return (
    <section className="relative py-16 md:py-24">
      <div className="mx-auto max-w-[1400px] px-6 md:px-10">
        <Reveal>
          <div className="flex items-end justify-between mb-8">
            <div>
              <p className="overline mb-4">In motion</p>
              <h2 className="font-serif font-light text-4xl md:text-6xl leading-[0.95] tracking-[-0.02em]">
                ASYA at CES 2027.
              </h2>
            </div>
            <p className="hidden md:block font-mono text-[11px] uppercase tracking-[0.2em] text-muted-foreground">
              Tap sound to hear the story
            </p>
          </div>
        </Reveal>

        <Reveal delay={0.1}>
          <div className="relative rounded-2xl overflow-hidden border border-white/10 group">
            <video
              ref={videoRef}
              data-testid="showcase-video"
              className="w-full aspect-video object-contain bg-black"
              poster={ASSETS.videoPoster}
              autoPlay
              muted
              loop
              playsInline
              preload="metadata"
            >
              <source src={ASSETS.video720} type="video/mp4" media="(max-width: 768px)" />
              <source src={ASSETS.video1080} type="video/mp4" />
            </video>

            <div className="absolute bottom-5 right-5 flex items-center gap-3">
              <button
                data-testid="video-sound-toggle"
                onClick={toggleMute}
                className="glass border border-white/15 rounded-full w-12 h-12 flex items-center justify-center hover:scale-105 transition-transform duration-300"
                aria-label={muted ? "Unmute video" : "Mute video"}
              >
                {muted ? <VolumeX className="w-5 h-5" /> : <Volume2 className="w-5 h-5" />}
              </button>
              <button
                data-testid="video-toggle"
                onClick={togglePlay}
                className="glass border border-white/15 rounded-full w-12 h-12 flex items-center justify-center hover:scale-105 transition-transform duration-300"
                aria-label={playing ? "Pause video" : "Play video"}
              >
                {playing ? <Pause className="w-5 h-5" /> : <Play className="w-5 h-5 ml-0.5" />}
              </button>
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
};
